import React, { useEffect, useRef, useState, useCallback } from "react";
import "./HeroVideo.scss";
import heroVideo from "../../../assests/videos/all_merge_demo.webm";
import heroVideoPortrait from "../../../assests/videos/all_merge_demo_portrait.webm";
import { useEntrance } from "../../../motion/useEntrance";
import { useParallax } from "../../../motion/useParallax";

const isPortrait = () => window.matchMedia("(orientation: portrait)").matches;

const HeroVideo: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  // Content rises + fades in on load; media drifts (parallax) as you scroll away.
  const contentRef = useEntrance<HTMLDivElement>({ selector: ":scope > *" });
  const mediaRef = useParallax<HTMLDivElement>({ amount: 140 });
  const [isPlaying, setIsPlaying] = useState(true);
  const [videoSrc, setVideoSrc] = useState(() =>
    isPortrait() ? heroVideoPortrait : heroVideo
  );

  useEffect(() => {
    const mq = window.matchMedia("(orientation: portrait)");
    const handleChange = (e: MediaQueryListEvent) => {
      setVideoSrc(e.matches ? heroVideoPortrait : heroVideo);
    };
    mq.addEventListener("change", handleChange);
    return () => mq.removeEventListener("change", handleChange);
  }, []);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.load();
      video.play().catch(() => setIsPlaying(false));
    }
  }, [videoSrc]);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.play().catch(() => setIsPlaying(false));
    }
  }, []);

  const togglePlayPause = useCallback(() => {
    const video = videoRef.current;
    if (!video) return;
    if (video.paused) {
      video.play().catch(() => {});
      setIsPlaying(true);
    } else {
      video.pause();
      setIsPlaying(false);
    }
  }, []);

  return (
    <section className="hero" aria-label="Nagarro end-to-end iGaming services">
      <div className="hero__media" ref={mediaRef}>
        <video
            ref={videoRef}
            className="hero__video"
            src={videoSrc}
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
          />
        <div className="hero__overlay" />
      </div>
      <button
        type="button"
        className="hero__play-pause"
        onClick={togglePlayPause}
        aria-label={isPlaying ? "Pause background video" : "Play background video"}
      >
        {isPlaying ? (
          <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <rect x="5" y="4" width="5" height="16" rx="1.5" />
            <rect x="14" y="4" width="5" height="16" rx="1.5" />
          </svg>
        ) : (
          <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M8 5.14v14l11-7-11-7z" />
          </svg>
        )}
      </button>

      <div className="hero__content" ref={contentRef}>
        <h1 className="hero__title">
          <span className="hero__title-line">End to End</span>
          <span className="hero__title-line hero__title-line--accent">
              iGaming Engineering
          </span>
        </h1>
        <span className="hero__rule" aria-hidden="true" />
        <p className="hero__subtitle">
Empowering iGaming operators, providers, and aggregators to accelerate go-to-market, modernize regulated platforms, and deliver safer, data-driven player experiences that drive retention.        </p>
      
      </div>

     
    </section>
  );
};

export default HeroVideo;
